import * as types from "./mutationTypes";

const moduleState = {
    achievementToastQueue : [],
    currentAchievementToast : null,
};

const moduleGetters = {
    achievementToastQueue : state => state.achievementToastQueue,
    currentAchievementToast : state => state.currentAchievementToast,
};

const actions = {
    showAchievementToast({ commit, state }, achievements) {
        commit(types.QUEUE_ACHIEVEMENT_TOAST, achievements);
        if (!state.currentAchievementToast) {
            commit(types.SET_ACHIEVEMENT_TOAST, state.achievementToastQueue.shift());
        }
    },

    dismissAchievementToast({ commit, state }) {
        if (state.achievementToastQueue.length > 0) {
            commit(types.SET_ACHIEVEMENT_TOAST, state.achievementToastQueue.shift());
        } else {
            commit(types.CLEAR_ACHIEVEMENT_TOAST);
        }
    }
};

const mutations = {
    [types.SET_ACHIEVEMENT_TOAST](state, achievement) {
        state.currentAchievementToast = achievement;
    },

    [types.QUEUE_ACHIEVEMENT_TOAST](state, achievements) {
        state.achievementToastQueue.push(...achievements);
    },

    [types.CLEAR_ACHIEVEMENT_TOAST](state) {
        state.currentAchievementToast = null;
    },
};

export default {
    state : moduleState,
    getters : moduleGetters,
    actions,
    mutations
};
